import React from 'react';
import styled from 'styled-components';

export const IrTags = ({ data, minified }) => {

  const getTags = () => {
    if (data && (typeof data === 'object')) {
      return data.map(tag => <Tag positive>{tag}</Tag>);
    }
    return null;
  };

  return <Container>
    <Table minified={minified}>
      <Heading minified={minified}>
        <h2>Tags</h2>
        <p>Below are the grantee's tags related to this report.</p>
      </Heading>
      <TableRow minified={minified}>
        <Body>
          { getTags() }
        </Body>
      </TableRow>
    </Table>
  </Container>;
};

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Table = styled.div`
  width: 100%;
  height: auto;
  min-height: 200px;
  background-color: #FFFFFF;
  border: ${({minified}) => minified ? 'none' : 'solid 1px #ccd7e3'};
  border-radius: 4px;
`;

const Heading = styled.div`
  padding: 20px;
  h2 {
    color: #46586b;
    font-size: ${({minified}) => minified ? '1.5' : '2em'};
    font-weight: bold;
  }
`;

const Body = styled.div`
  padding-top: 0px;
  b {
    color: #46586b;
  }
  span.spaced {
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  li {
    list-style: none;
  }
`;

const TableRow = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #f5f8fa;
  border-top: solid 1px #ccd7e3;
  border-bottom: solid 1px #ccd7e3;
  border-left: ${({minified}) => minified ? 'solid 1px #ccd7e3' : 'none'};
  border-right: ${({minified}) => minified ? 'solid 1px #ccd7e3' : 'none'};
  display: flex;
  flex-direction: row;
`;

const Tag = styled.div`
  width: auto;
  min-width: 85px;
  height: 32px;
  padding: 4px;
  background-color: ${props => props.positive ? '#cdedcd' : '#fcd7d9'};
  color: ${props => props.positive ? '#207958' : '#d15b5c'};
  text-align: center;
  border-radius: 16px;
  padding-right: 4px !important;
  text-align: center;
  float: left;
  margin-right: 3px;
  margin-bottom: 3px;
`;
